export function getCartUrl(bump1: boolean, bump2: boolean): string {
  if (bump1 && bump2) {
    return 'https://www.elplacerquenutre.com/cart/45068564660326:1'
  }
  if (bump1) {
    return 'https://www.elplacerquenutre.com/cart/44835922083942:1'
  }
  if (bump2) {
    return 'https://www.elplacerquenutre.com/cart/45066604380262:1'
  }
  return 'https://www.elplacerquenutre.com//cart/45066643734630:1'
}

export const BASE_CART_URL =
  'https://www.elplacerquenutre.com//cart/45066643734630:1'
